import { Component, Input, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { PieChartDataset } from '../models';

@Component({
    selector: 'app-stat-piechart',
    templateUrl: './stat-piechart.component.html',
    styleUrls: ['./stat-piechart.component.scss'],
    standalone: false
})
export class StatPiechartComponent implements OnInit {
  @Input() chartData: PieChartDataset[] | any;
  @Input() chartTitles: string[] = [];
  @Input() colorArray?: string[];
  @Input() showLabel = false;

  options!: EChartsOption;

  ngOnInit(): void {
    this.options = {
      legend: {
        data: this.chartTitles,
        orient: 'vertical',
        left: '20',
      },
      color: this.colorArray,
      tooltip: {},
      series: [
        {
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center',
          },
          labelLine: {
            show: false,
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '20',
            },
          },
          data: this.chartData,
        },
      ],
    };
  }
}
